import {Injectable} from '@angular/core';

import {HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import {BaseService} from './BaseService';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner'
import 'rxjs/add/operator/map';


@Injectable()
export class SignupService {
    usertype;

    constructor(private http: HttpClient, private baseurl: BaseService, private spinnerService: Ng4LoadingSpinnerService) {}


    signupuser(user: any, port, contacts): Observable<any>  {
        console.log(user);
        if (user.companytype == "E") {
            this.usertype = "EA";
        } else if(user.companytype == "CFS"){
            this.usertype = "EA";
        } else {
            this.usertype = "BW";
        }
        let url: string = '/createcompany';
        let body = JSON.stringify({
            companyName: user.companyname, iec: user.ieccode, portCodes: port, companytype: user.companytype, stuffingType: user.stuffingType, userVOs: [
                {
                    username: user.username,
                    password: user.password,
                    usertype: this.usertype,
                    firstname: user.firstname,

                }],
            contactVOs: contacts
        }); console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res: Response) => {
            res;
            this.spinnerService.hide()
            return res;

        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
    
      createChaCompanyMaster(chaCompanyMasterVO:any): Observable<any>  {       
        let url: string = '/createChaCompanyMaster';
        let body = JSON.stringify(chaCompanyMasterVO);
         console.log(body)
        const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');
        this.spinnerService.show()
        return this.http.post(this.baseurl.url + url, body, {headers}).map((res) => {
            res;
            this.spinnerService.hide()
            return res;

        }).catch(
            (error: Response) => {
                this.spinnerService.hide()
                return Observable.throw(error);
            });
    }
}




// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/service/SignupService.ts